module.exports = __webpack_public_path__ + "img/icon-funding-old.8bd32708.svg";